import React, { useEffect, useState, useContext } from 'react'
import Layout from '../Layout'
import DashboardLayout from '../DashboardLayout'
import { Pagination } from '@material-ui/lab'
import axios from 'axios'
import AuthContext from '../../../Product/context/auth/authContext'
import { capitalize } from '../../../Product/common/components'

const PayoutHistory = () => {
    const authContext = useContext(AuthContext)
    const { user, loadUser, isAuthenticated } = authContext

    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const [totalItems, setTotalItems] = useState(0)
    const [payouts, setPayouts] = useState([])

    // i18n stub for the demo, replace with your t() from useTranslation if needed
    const t = (key) => {
        const dict = {
            showing: 'Showing',
        }
        return dict[key] || key
    }

    useEffect(() => {
        const fetchPayouts = async () => {
            setLoading(true)
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}auctionpay/paystack/getTransfersList`,
                    {
                        pageNo: page,
                        perPage: perPage,
                        recipient: user?.card_profileid,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    },
                )

                setPayouts(response.data?.data || [])
                setTotalItems(response.data?.totalCount || 0)
            } catch (err) {
                setPayouts([])
            }
            setLoading(false)
        }
        fetchPayouts()
    }, [page, perPage])

    const handlePageChange = (_, value) => {
        setPage(value)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        if (isNaN(date)) return '-'
        return date.toLocaleString()
    }

    return (
        <Layout>
            <DashboardLayout title="Payout History" subtitle="Items" seller>
                <div className="mt-5">
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Payout ID</th>
                                    <th>Amount</th>
                                    <th>Currency</th>
                                    <th>Status</th>

                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && payouts.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="text-center">
                                            No data found
                                        </td>
                                    </tr>
                                )}
                                {payouts.map((item) => (
                                    <tr key={item.id}>
                                        <td>{formatDate(item.createdAt)}</td>
                                        <td>{item.id}</td>
                                        <td>
                                            {item.amount != null
                                                ? (item.amount / 100).toLocaleString(undefined, {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                  })
                                                : '-'}
                                        </td>
                                        <td>{item.currency || '-'}</td>
                                        <td>{item.status ? capitalize(item.status) : '-'}</td>

                                        <td>{item.recipient?.name || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex mt-3 pagination-wrapper se">
                        <div className="ml-auto page-showing">
                            {t('showing')} {totalItems === 0 ? 0 : perPage * (page - 1) + 1} -{' '}
                            {perPage * page > totalItems ? totalItems : perPage * page} of{' '}
                            {totalItems}
                        </div>
                        <Pagination
                            count={Math.max(1, Math.ceil(totalItems / perPage))}
                            page={page}
                            onChange={handlePageChange}
                        />
                    </div>
                </div>
            </DashboardLayout>
        </Layout>
    )
}

export default PayoutHistory
